export const INSPECTION_BASE_VIEWS = ['Passenger', 'Driver', 'Front', 'Rear', 'Top', 'DentArch'] as const;

export type InspectionBaseView = (typeof INSPECTION_BASE_VIEWS)[number];

export const MOBILE_VIEW_NAME = 'Mobile';
export const MOBILE_VIEW_ALIASES = ['SCAN', 'INTERIOR', 'vin'] as const;

const BASE_VIEW_SET = new Set<string>(INSPECTION_BASE_VIEWS);

export const isMobileInspectionTerminal = (terminal?: string | null): boolean =>
  (terminal || '').toLowerCase() === 'mobile';

export const normalizeInspectionViewName = (viewName?: string | null): string => {
  if (!viewName) {
    return '';
  }

  if ((MOBILE_VIEW_ALIASES as readonly string[]).includes(viewName)) {
    return MOBILE_VIEW_NAME;
  }

  return viewName;
};

export const isInspectionBaseView = (viewName?: string | null): boolean =>
  Boolean(viewName && BASE_VIEW_SET.has(viewName));

export const orderInspectionViews = (views: string[]): string[] => {
  const uniqueViews = Array.from(new Set(views.filter(Boolean)));
  const orderedBaseViews = INSPECTION_BASE_VIEWS.filter(view => uniqueViews.includes(view));
  const extraViews = uniqueViews.filter(view => !BASE_VIEW_SET.has(view));
  return [...orderedBaseViews, ...extraViews];
};
